module.exports = __webpack_public_path__ + "img/tianjing.78899569.png";